import RevenueChart from "./revenue-chart/revenue-chart";
import L2LClientOpportunityTable from "./client-opportunity-table/client-opportunity-table";
import PropTypes from 'prop-types';

const DashboardL2L = ({L2LWidgetData}) => {
    if (!L2LWidgetData) {
        return;
    }

    return (
        <>
            <RevenueChart revenueChartData={L2LWidgetData.RevenueChart} />
            <L2LClientOpportunityTable clientOpportunityData={L2LWidgetData.ClientsOpportunityTable} />
        </>
    );
}

export default DashboardL2L;

DashboardL2L.propTypes = {
    L2LWidgetData: PropTypes.shape({
      RevenueChart: PropTypes.shape({
        InitialContact: PropTypes.shape({
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          NumberOfDeals: PropTypes.number.isRequired,
        }).isRequired,
        StakeholdersIdentified: PropTypes.shape({
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          NumberOfDeals: PropTypes.number.isRequired,
        }).isRequired,
        Product_Process: PropTypes.shape({
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          NumberOfDeals: PropTypes.number.isRequired,
        }).isRequired,
        DealNurturing: PropTypes.shape({
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          NumberOfDeals: PropTypes.number.isRequired,
        }).isRequired,
        Terms_Contract: PropTypes.shape({
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          NumberOfDeals: PropTypes.number.isRequired,
        }).isRequired,
        RevenueBooked: PropTypes.shape({
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          NumberOfDeals: PropTypes.number.isRequired,
        }).isRequired,
        Total: PropTypes.shape({
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          NumberOfDeals: PropTypes.number.isRequired,
        }).isRequired,
      }).isRequired,
      ClientsOpportunityTable: PropTypes.arrayOf(
        PropTypes.shape({
          ClientName: PropTypes.string.isRequired,
          ARRAmount: PropTypes.number.isRequired,
          ServicesAmount: PropTypes.number.isRequired,
          WeighedAmount: PropTypes.number.isRequired,
          Opportunities: PropTypes.arrayOf(
            PropTypes.shape({
              OpportunityName: PropTypes.string.isRequired,
              DealType: PropTypes.string.isRequired,
              RevenueType: PropTypes.string.isRequired,
              Status: PropTypes.string.isRequired,
              ARRAmount: PropTypes.number.isRequired,
              ServicesAmount: PropTypes.number.isRequired,
              WeighedAmount: PropTypes.number.isRequired,
            }).isRequired
          ).isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
  };